import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import styles from "./lightbox.module.scss";

function NavigationPrev(props) {
  return (
    <button
      className={classNames(styles.navigation, styles.navigationPrev)}
      onClick={props.innerProps.onClick}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.5 3L16 4.5L8.446 12L16 19.5L14.5 21L5.5 12L14.5 3Z"
          fill="#c9cbcc"
        />
      </svg>
    </button>
  );
}

NavigationPrev.propTypes = {
  innerProps: PropTypes.object
};

export default NavigationPrev;
